import { render, staticRenderFns } from "./FacturaHistorial.vue?vue&type=template&id=1fff9e0d&scoped=true"
import script from "./FacturaHistorial.vue?vue&type=script&lang=ts"
export * from "./FacturaHistorial.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fff9e0d",
  null
  
)

export default component.exports